import React from "react";
import Enum from "../constants/Enum";

const {
  ADD,
  CANCEL,
  PICTURE,
  CHANGE,
  ADDPROFILE,
  CASINO,
  CHECK,
  DELETE,
  INFO,
  MENU,
  BACK,
  SEARCH,
  HEADERLOGO,
  SPLIT,
  MORE,
  WARNING,
  BEFORE_BOOKMARK,
  AFTER_BOOKMARK,
  STAR,
  NEXT,
  SHARE,
  PART,
  CONFIRM,
} = Enum;

export const svgInfo = {
  [ADD]: {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    inContext: [
      <path
        d="M6.83537 13.6707V0M13.6707 6.83536L0 6.83537"
        stroke="#CFD3DB"
        strokeWidth="3"
      />,
    ],
  },
  [CANCEL]: {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "#CFD3DB",
    inContext: [
      <path d="M5 19.5L19.5 5" strokeWidth="3" />,
      <path d="M19.5 19.5L5 5" strokeWidth="3" />,
    ],
  },
  [PICTURE]: {
    width: "49",
    height: "49",
    viewBox: "0 0 49 49",
    fill: "none",
    infill: "#DADEE5",
    inContext: [
      <path
        d="M48.125 42.875V6.125C48.125 3.2375 45.7625 0.875 42.875 0.875H6.125C3.2375 0.875 0.875 3.2375 0.875 6.125V42.875C0.875 45.7625 3.2375 48.125 6.125 48.125H42.875C45.7625 48.125 48.125 45.7625 48.125 42.875ZM15.3125 28.4375L21.875 36.3387L31.0625 24.5L42.875 40.25H6.125L15.3125 28.4375Z"
        fill="#DADEE5"
      />,
    ],
  },
  [CHANGE]: {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    inContext: [
      <path
        d="M20.1509 31.8809V36.6667L26.7318 29.9286L20.1276 23.1905V28.2857C17.9806 28.3333 15.8337 27.5476 14.2001 25.8809C11.5864 23.2143 11.1663 19.2143 12.8232 16.0476L10.2562 13.4286C7.26913 18.0476 7.7592 24.3333 11.7498 28.4048C14.0367 30.7143 17.0238 31.8809 20.0109 31.8809H20.1509Z"
        fill="#8A929E"
      />,
      <path
        d="M27.1752 23.9524L29.7423 26.5714C32.7294 21.9524 32.2393 15.6429 28.2721 11.5952C25.9617 9.21428 22.9046 8.09523 19.8709 8.14285V3.33333L13.2666 10.0714L19.8709 16.7857V11.6667H20.0109C22.1112 11.6667 24.1882 12.4762 25.7984 14.119C28.4121 16.7857 28.8321 20.7857 27.1752 23.9524Z"
        fill="#8A929E"
      />,
    ],
  },
  [ADDPROFILE]: {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    inContext: [
      <circle
        cx="14"
        cy="14"
        r="13"
        fill="#F1F2F4"
        stroke="white"
        strokeWidth="2"
      />,
      <path
        d="M14.2355 20.8348V7.16406M21.0709 13.9994L7.40015 13.9994"
        stroke="#CFD3DB"
        strokeWidth="3.42857"
      />,
    ],
  },
  [CASINO]: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    inContext: [
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM7.5 18C6.67 18 6 17.33 6 16.5C6 15.67 6.67 15 7.5 15C8.33 15 9 15.67 9 16.5C9 17.33 8.33 18 7.5 18ZM7.5 9C6.67 9 6 8.33 6 7.5C6 6.67 6.67 6 7.5 6C8.33 6 9 6.67 9 7.5C9 8.33 8.33 9 7.5 9ZM12 13.5C11.17 13.5 10.5 12.83 10.5 12C10.5 11.17 11.17 10.5 12 10.5C12.83 10.5 13.5 11.17 13.5 12C13.5 12.83 12.83 13.5 12 13.5ZM16.5 18C15.67 18 15 17.33 15 16.5C15 15.67 15.67 15 16.5 15C17.33 15 18 15.67 18 16.5C18 17.33 17.33 18 16.5 18ZM16.5 9C15.67 9 15 8.33 15 7.5C15 6.67 15.67 6 16.5 6C17.33 6 18 6.67 18 7.5C18 8.33 17.33 9 16.5 9Z"
        fill="#B7BDCB"
      />,
    ],
  },
  [CHECK]: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    inContext: [
      <path
        d="M5 10.1053L11.1765 16L19 8"
        stroke="#DADEE6"
        strokeWidth="2.5"
      />,
    ],
  },
  [DELETE]: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    inContext: [
      <path
        d="M7.5 4.8V3H16.5V4.8H21V6.6H19.2V20.1C19.2 20.3387 19.1052 20.5676 18.9364 20.7364C18.7676 20.9052 18.5387 21 18.3 21H5.7C5.46131 21 5.23239 20.9052 5.0636 20.7364C4.89482 20.5676 4.8 20.3387 4.8 20.1V6.6H3V4.8H7.5ZM6.6 6.6V19.2H17.4V6.6H6.6ZM9.3 9.3H11.1V16.5H9.3V9.3ZM12.9 9.3H14.7V16.5H12.9V9.3Z"
        fill="#B7BDCB"
      />,
    ],
  },
  [INFO]: {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    inContext: [
      <path
        d="M8.1665 11.6668H9.83317V13.3335H8.1665V11.6668ZM8.1665 5.00016H9.83317V10.0002H8.1665V5.00016ZM8.9915 0.833496C4.3915 0.833496 0.666504 4.56683 0.666504 9.16683C0.666504 13.7668 4.3915 17.5002 8.9915 17.5002C13.5998 17.5002 17.3332 13.7668 17.3332 9.16683C17.3332 4.56683 13.5998 0.833496 8.9915 0.833496ZM8.99984 15.8335C5.3165 15.8335 2.33317 12.8502 2.33317 9.16683C2.33317 5.4835 5.3165 2.50016 8.99984 2.50016C12.6832 2.50016 15.6665 5.4835 15.6665 9.16683C15.6665 12.8502 12.6832 15.8335 8.99984 15.8335Z"
        fill="#8A929E"
      />,
    ],
  },
  [MENU]: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#8A929E",
    inContext: [
      <rect x="3" y="11" width="15" height="3" rx="1.28571" fill="#8A929E" />,
      <path
        d="M3 6.28571C3 5.57563 3.57563 5 4.28571 5H19.7143C20.4244 5 21 5.57563 21 6.28571V6.71429C21 7.42437 20.4244 8 19.7143 8H4.28571C3.57563 8 3 7.42437 3 6.71429V6.28571Z"
        fill="#8A929E"
      />,
      <path
        d="M3 18.2857C3 17.5756 3.57563 17 4.28571 17H18.7143C19.4244 17 20 17.5756 20 18.2857V18.7143C20 19.4244 19.4244 20 18.7143 20H4.28571C3.57563 20 3 19.4244 3 18.7143V18.2857Z"
        fill="#8A929E"
      />,
    ],
  },
  [SEARCH]: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    inContext: [
      <path
        d="M15.9193 12C15.9193 15.5535 12.9521 18.5 9.20964 18.5C5.46719 18.5 2.5 15.5535 2.5 12C2.5 8.44649 5.46719 5.5 9.20964 5.5C12.9521 5.5 15.9193 8.44649 15.9193 12Z"
        stroke="#8A929E"
        strokeWidth="3"
      />,
      <path
        d="M15.8734 15.5567L21.0001 18.9192"
        stroke="#8A929E"
        strokeWidth="3"
        strokeLinecap="round"
      />,
    ],
  },
  [BACK]: {
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    fill: "none",
    inContext: [
      <path
        d="M16.2502 5.41699L8.44358 12.2477C7.98826 12.6462 7.98826 13.3545 8.44358 13.7529L16.2502 20.5837"
        stroke="#8A929E"
        strokeWidth="3"
        strokeLinecap="round"
      />,
    ],
  },
  [HEADERLOGO]: {
    width: "138",
    height: "42",
    viewBox: "0 0 138 42",
    fill: ["#0B70FD", "#141719"],
    inContext: [
      <g clipPath="url(#clip0)">
        <path
          d="M40.985 21.2256C40.985 18.5401 39.5026 16.1773 37.2432 14.7636C39.5026 13.3498 40.985 10.9806 40.985 8.30154C40.985 3.96984 37.1332 0.458008 32.3815 0.458008C32.3491 0.458008 32.3167 0.464463 32.2844 0.464463C32.252 0.464463 32.2261 0.458008 32.2002 0.458008H6.68734C2.99733 0.458008 0 3.18226 0 6.55207V35.8927C0 39.256 2.99733 41.9868 6.68734 41.9868H32.1873C32.1937 41.9868 32.1937 41.9868 32.2002 41.9868C32.2585 41.9868 32.3167 41.9932 32.375 41.9932C37.1267 41.9932 40.9786 38.4814 40.9786 34.1497C40.9786 31.4642 39.4961 29.1014 37.2368 27.6876C39.5026 26.2803 40.985 23.9111 40.985 21.2256Z"
          fill="#0B70FF"
        />
        <path
          d="M117.168 0.793945C114.475 0.793945 112.105 2.27227 110.688 4.52527C109.27 2.27227 106.894 0.793945 104.207 0.793945C99.8635 0.793945 96.3418 4.63502 96.3418 9.37341C96.3418 9.40569 96.3483 9.43797 96.3483 9.47024C96.3483 9.50252 96.3418 9.52834 96.3418 9.55417V34.9892C96.3418 38.6753 99.0802 41.6578 102.453 41.6578H131.882C135.255 41.6578 137.994 38.6688 137.994 34.9892V9.56062C137.994 9.55417 137.994 9.55417 137.994 9.54771C137.994 9.48961 138 9.43151 138 9.37341C138 4.63502 134.478 0.793945 130.135 0.793945C127.441 0.793945 125.072 2.27227 123.654 4.52527C122.237 2.27227 119.861 0.793945 117.168 0.793945Z"
          fill="#0B70FF"
        />
        <path
          d="M63.3711 3.11805L46.287 32.6265C43.8788 36.7839 46.8891 41.9871 51.7055 41.9871H85.8737C90.6902 41.9871 93.7005 36.7904 91.2922 32.6265L74.2081 3.11805C71.7999 -1.03935 65.7794 -1.03935 63.3711 3.11805Z"
          fill="#0B70FF"
        />
        <path
          d="M60.2962 30.49C59.3769 30.49 58.626 29.7476 58.626 28.8244V27.4107C58.626 26.494 59.3705 25.7451 60.2962 25.7451C61.2155 25.7451 61.9664 26.4875 61.9664 27.4107V28.8244C61.9664 29.7476 61.2155 30.49 60.2962 30.49Z"
          fill="#141719"
        />
        <path
          d="M65.6692 30.49C64.75 30.49 63.999 29.7476 63.999 28.8244V27.4107C63.999 26.494 64.7435 25.7451 65.6692 25.7451C66.5885 25.7451 67.3395 26.4875 67.3395 27.4107V28.8244C67.3395 29.7476 66.595 30.49 65.6692 30.49Z"
          fill="#141719"
        />
        <path
          d="M25.118 13.8025C24.1987 13.8025 23.4478 13.0601 23.4478 12.1369V10.7232C23.4478 9.80646 24.1922 9.05762 25.118 9.05762C26.0372 9.05762 26.7882 9.80001 26.7882 10.7232V12.1369C26.7882 13.0601 26.0372 13.8025 25.118 13.8025Z"
          fill="#141719"
        />
        <path
          d="M30.491 13.8025C29.5718 13.8025 28.8208 13.0601 28.8208 12.1369V10.7232C28.8208 9.80646 29.5653 9.05762 30.491 9.05762C31.4103 9.05762 32.1612 9.80001 32.1612 10.7232V12.1369C32.1612 13.0601 31.4168 13.8025 30.491 13.8025Z"
          fill="#141719"
        />
        <path
          d="M113.393 22.3425C112.474 22.3425 111.723 21.6001 111.723 20.677V19.2632C111.723 18.3465 112.468 17.5977 113.393 17.5977C114.313 17.5977 115.064 18.34 115.064 19.2632V20.677C115.064 21.6001 114.313 22.3425 113.393 22.3425Z"
          fill="#141719"
        />
        <path
          d="M118.767 22.3425C117.848 22.3425 117.097 21.6001 117.097 20.677V19.2632C117.097 18.3465 117.841 17.5977 118.767 17.5977C119.686 17.5977 120.437 18.34 120.437 19.2632V20.677C120.437 21.6001 119.686 22.3425 118.767 22.3425Z"
          fill="#141719"
        />
      </g>,
      <defs>
        <clipPath id="clip0">
          <rect width="138" height="42" fill="white" />
        </clipPath>
      </defs>,
    ],
  },
  [SPLIT]: {
    width: "2",
    height: "12",
    viewBox: "0 0 2 12",
    fill: "none",
    inContext: [<path d="M1 0V12" stroke="#CFD3DB" />],
  },
  [MORE]: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    inContext: [
      <circle cx="12" cy="8.5" r="2" fill="#C4C4C4" />,
      <circle cx="12" cy="15.5" r="2" fill="#C4C4C4" />,
    ],
  },
  [BEFORE_BOOKMARK]: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#8A929E",
    inContext: [
      <path
        d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z"
        fill="#8A929E"
      />,
    ],
  },
  [WARNING]: {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    inContext: [
      <path
        d="M3.40455 31.9981C2.63262 33.3314 3.59473 35.0002 5.1354 35.0002H34.8643C36.4049 35.0002 37.3671 33.3314 36.5951 31.9981L21.7307 6.32315C20.9604 4.99258 19.0393 4.99258 18.269 6.32315L3.40455 31.9981ZM21.6665 30.0002H18.3332V26.6668H21.6665V30.0002ZM21.6665 23.3335H18.3332V16.6668H21.6665V23.3335Z"
        fill="#DADEE6"
      />,
    ],
  },
  [AFTER_BOOKMARK]: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#0B70FD",
    inContext: [
      <path
        d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3Z"
        fill="#0B70FD"
      />,
    ],
  },
  [STAR]: {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: ["#F1F2F4", "#DADEE6"],
    inContext: [
      <path
        d="M0 5C0 2.23858 2.23858 0 5 0H17C19.7614 0 22 2.23858 22 5V17C22 19.7614 19.7614 22 17 22H5C2.23858 22 0 19.7614 0 17V5Z"
        fill="#F1F2F4"
      />,
      <path
        d="M11.0002 15.831L16.6652 19.2502L15.1618 12.806L20.1668 8.47016L13.576 7.911L11.0002 1.8335L8.42433 7.911L1.8335 8.47016L6.8385 12.806L5.33516 19.2502L11.0002 15.831Z"
        fill="#DADEE6"
      />,
    ],
  },
  [NEXT]: {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    inContext: [
      <path
        d="M7.49984 15.8335L13.3064 10.7527C13.7617 10.3543 13.7617 9.646 13.3064 9.24759L7.49984 4.16683"
        stroke="#8A929E"
        strokeWidth="3"
        strokeLinecap="round"
      />,
    ],
  },
  [SHARE]: {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "#DADEE6",
    inContext: [
      <path
        d="M12.4192 16C12.3117 16 12.1907 15.9768 12.0832 15.942C11.7606 15.8259 11.5456 15.5473 11.5456 15.2456V12.4599C10.0939 12.4135 6.69333 12.6805 3.52123 15.7214C3.26585 15.9652 2.86262 16.0348 2.52659 15.9071C2.17712 15.7795 1.97551 15.4661 2.00239 15.1411C2.01583 14.9786 2.44594 11.1716 5.55083 8.71096C7.66109 7.03959 10.188 6.59853 11.5052 6.49407V3.75488C11.5052 3.4531 11.7203 3.17454 12.0429 3.05847C12.352 2.9424 12.7284 3.00044 12.9838 3.22097L19.7446 8.9547C19.9059 9.09398 20 9.2913 20 9.48861C20 9.68593 19.9059 9.88324 19.7446 10.0225L13.0241 15.7795C12.8628 15.9188 12.6477 16 12.4192 16Z"
        fill="#DADEE6"
      />,
    ],
  },
  [PART]: {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "#DADEE6",
    inContext: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.06094 6.23418C8.06094 8.01815 9.51114 9.46835 11.2951 9.46835C13.0791 9.46835 14.5293 8.01815 14.5293 6.23418C14.5293 4.4502 13.0791 3 11.2951 3C9.51114 3 8.06094 4.4502 8.06094 6.23418ZM4.76905 18.25H17.9014C18.2927 18.25 18.615 17.9277 18.6265 17.5249V14.3138C18.6265 14.1871 18.6035 13.1053 17.5561 12.0579C16.3246 10.8264 14.2299 10.1933 11.341 10.1933C4.2281 10.1933 4.05545 14.1411 4.05545 14.3253L4.04395 17.5249C4.04395 17.7206 4.13602 17.9162 4.26263 18.0428C4.38923 18.1694 4.57338 18.25 4.76905 18.25Z"
        fill="#DADEE6"
      />,
    ],
  },
  [CONFIRM]: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: ["white", "#E5E8EC"],
    inContext: [
      <path
        d="M0 5C0 2.23858 2.23858 0 5 0H19C21.7614 0 24 2.23858 24 5V19C24 21.7614 21.7614 24 19 24H5C2.23858 24 0 21.7614 0 19V5Z"
        fill="white"
      />,
      <path
        d="M17.7138 5.84135C18.05 6.12063 17.8793 6.61427 17.8793 6.61427L14.6854 20.903C14.6854 20.903 14.6014 21.3315 14.251 21.3655C13.8706 21.4013 13.7111 21.01 13.7111 21.01L11.4384 15.3893C11.4384 15.3893 11.3543 15.1395 11.1393 14.9308C10.9244 14.7221 10.5396 14.6621 10.5396 14.6621L4.30412 13.7501C4.30412 13.7501 3.96348 13.6724 3.92831 13.2867C3.88802 12.8527 4.43726 12.5907 4.43726 12.5907L16.8725 5.76476C16.8725 5.76476 17.4103 5.5845 17.7138 5.84135Z"
        fill="#E5E8EC"
      />,
    ],
  },
};

// info에서 가져야할 필수 속성
// default form: { width: "", height: "", fill: "none", viewBox: "", inContext: [] }
